import * as myModule from './popular.js';
import 'gasparesganga-jquery-loading-overlay/dist/loadingoverlay.min.js';
'use strict';
const tabs = {
	tab : $('.js-productionTabs__tab'),
	toggleTab(id) {
		if ($(`.js-productionTabs__tab[data-id="${id}"]`).is(':hidden')) {
			this.tab.hide();
			$(`.js-productionTabs__tab[data-id="${id}"]`).fadeIn();
		}
	}
}
$(document).on('click', '.js-productionTabs__button', function() {
	$('.js-productionTabs__button').removeClass('current');
	$(this).addClass('current');
	tabs.toggleTab($(this).data('tab'));
	myModule.model.showFoot();
	setTimeout(()=> {
		myModule.model.defaultMainHeight = $('.js-popular__main').height();
		
	}, 300)
});
tabs.toggleTab('2');

const showLoader = function() {
	$.LoadingOverlaySetup({
		background: 'rgba(2, 53, 171, .25)',
		image: '../images/loader.svg',
		imageColor: 'rgba(0, 0, 0, 0.0)',
		minSize: 300,
		imageAnimation: false
	});
	$.LoadingOverlay('show');
  }
  const hideLoader = function(time) {
	if (time === undefined) time = 0;
	setTimeout(function() {
		$.LoadingOverlay('hide');
	}, time)
}

window.showLoader = showLoader;
window.hideLoader = hideLoader;


